// for employee information
export const EMPLOYEES_COUNT_INFO = "employee_count_info";
export const EMPLOYEES_COUNT_INFO_SUCCESS = "employee_count_info_success";
export const EMPLOYEES_COUNT_INFO_FAILURE = "employee_count_info_failure";
